import React, { FC, useState } from 'react'
import { Flex, Box, Input } from 'front-end/src/components'
import { useLooopTheme } from '../../../../public-api/hooks/useLooopTheme'
import { radii } from '../../../chakraThemeExtension'
import Tooltip from '../../tooltip/Tooltip'
import { InputProps } from '@chakra-ui/react'
import ColorPickerButton from '../../color-picker-button/ColorPickerButton'
import { css } from '@emotion/react'
import classNames from 'classnames'
import { brandColors } from 'shared/basicPalette'

type onChangeEventCallback = (
  val: string,
  event?: React.ChangeEvent<HTMLInputElement>
) => void

export interface IInputColourProps {
  colorHex: string
  inputId: string
  onChange: onChangeEventCallback
}

type ExtendedInputColourProps = IInputColourProps & InputProps

const InputColour: FC<ExtendedInputColourProps> = (props) => {
  const { theme } = useLooopTheme()
  const [focus, setFocus] = useState(false)
  const [error, setError] = useState(false)

  const onBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    if (/^#[0-9A-F]{6}$/i.test(value)) {
      setError(false)
    } else {
      setError(true)
    }
    setFocus(false)
  }

  const onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    e.preventDefault && e.preventDefault()
    const value = e.target.value
    e.persist()
    if (props.onChange) {
      props.onChange(value, e)
    }
  }

  return (
    <Flex
      bg={brandColors.grey.lightest}
      pl="16px"
      borderRadius="base"
      borderWidth="1px"
      borderStyle="solid"
      position="relative"
      borderColor={
        error
          ? brandColors.red
          : focus
          ? theme.colors.buttonPrimary.default
          : brandColors.grey.lightest
      }
      className={classNames(props.className, { error: error })}
    >
      <Input
        variant="unstyled"
        value={props.colorHex}
        maxWidth="124px"
        minHeight="40px"
        onFocus={() => {
          setFocus(true)
        }}
        onBlur={onBlur}
        onChange={onChange}
        id={props.inputId}
      />
      {error && (
        <Tooltip text="Incorrect HEX value">
          <Box
            css={css`
              position: absolute;
              right: 42px;
              top: 50%;
              transform: translate(-50%, -50%);
              font-size: 14px;
              line-height: 18px;
              text-align: center;
              background-color: ${brandColors.red.mid};
              height: 18px;
              width: 18px;
              border-radius: 50%;
              color: white;
            `}
          >
            !
          </Box>
        </Tooltip>
      )}
      <Box
        css={css`
          .ColorPickerButton,
          .swatch {
            border-radius: 0;
            border-top-right-radius: ${radii.base};
            border-bottom-right-radius: ${radii.base};
          }
          .ColorPickerButton {
            height: 100%;
            border: none;
            &:hover {
              box-shadow: 0 0 0 1px ${brandColors.grey.light};
            }
          }
        `}
      >
        <ColorPickerButton
          simplified={true}
          color={props.colorHex}
          onChange={(value) => {
            props.onChange(value)
          }}
        />
      </Box>
    </Flex>
  )
}

export default InputColour
